import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";

//代理uid的code
const useInviteCode = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const invite_code = searchParams.get("invite_code");

  useEffect(() => {
    if (invite_code) {
      Cookies.set("invite_code", invite_code, { expires: 1 });
    }
  }, [invite_code]);

  return invite_code || Cookies.get("invite_code");
};

export default useInviteCode;
